import React from 'react';
import iconPaths from './../../../assets/fonts/app-icons/selection.json';
import { AppIcon as ApppIcon } from '../common';

// TODO: Migrar esta carpeta.
export const AppIconShowCase = () => (
    <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
        {iconPaths.icons.map((icon) => icon.properties.name).map((name) => (
            <div key={`app-icon-${name}`} style={{ flex: '1 1 200px', margin: 10 }}>
                <ApppIcon name={name} size={40} style={{ fill: 'black' }} />
                <p>{name}</p>
            </div>
        ))}
    </div>
);

export default ApppIcon;
